export default "__VITE_ASSET__BzHf15Rt__"